import { createContext, useContext } from 'react';

/**
 * Tanlagichlarning (`Select`, `Combobox`) ko'rinish uslubi.
 *
 * `default` — ilova bo'ylab ishlatilayotgan joriy ko'rinish.
 * `refined` — yumshoq chegara, kattaroq burchak, aniq fokus halqasi va
 * ajralib turadigan o'chirilgan holat. Hozircha faqat "Xodimni tizimga
 * qo'shish" oynasida yoqilgan: kontekst orqali, shuning uchun oyna ichidagi
 * barcha tanlagichlar (shu jumladan `ScopePicker` ichidagilar) bir xil
 * ko'rinadi va boshqa sahifalar o'zgarmaydi.
 */
export type FieldAppearance = 'default' | 'refined';

export const FieldAppearanceContext = createContext<FieldAppearance>('default');

export const useFieldAppearance = (): FieldAppearance => useContext(FieldAppearanceContext);
